import {OverviewInfoContent} from './OverviewInfoContent'
import styles from './Sidebar.module.css'
import {ClientOnly} from '../ClientOnly'

export function OverviewPanel() {
  return (
    <ClientOnly>
      <OverviewPanelContent />
    </ClientOnly>
  )
}

/** Full Overview sidebar panel */
function OverviewPanelContent() {
  return (
    <section className={styles.sidebar} aria-label="Info sidebar">
      <OverviewInfoContent />
    </section>
  )
}
